import { debounce } from './utilities';
import config from '../config';

interface IConfig {
  padding: number,
  selectors: IFitToScreenSelectors
}

interface IFitToScreenSelectors {
  subtracted: string
}

class FitToScreen {

  private config:IConfig;

  constructor() {
    this.config = {
      padding: config.gutter * 4,
      selectors: {
        subtracted: 'header, .links-scroll-bar'
      }
    }
  }
  
  public load = (htmlElement:HTMLElement) => {
    htmlElement.style.height = this.calcHeight();
    window.addEventListener('resize', this.resize.bind(this, htmlElement));
  }

  private resize = debounce((htmlElement:HTMLElement) => {
    htmlElement.style.height = this.calcHeight();
  }, 250);
  
  private calcHeight = () => {
    return `${ window.innerHeight - this.config.padding - this.subtractedNodesTotalHeight() }px`;
  }

  private subtractedNodesTotalHeight = () => {
    return Array.from(document.querySelectorAll(this.config.selectors.subtracted)).reduce((acc: number, htmlElement: HTMLElement) => {
        if (htmlElement) acc += htmlElement.offsetHeight;
        return acc;
      }, 0);
  };
}

export default new FitToScreen();
